
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWind8 as ObiWind8Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-8.js';
 
 
 

 
 export const ObiWind8 = createComponent({
   react: React,
   tagName: 'obi-wind-8',
   elementClass: ObiWind8Element,
   events: {
     
   }
  });
 
 